export default "__VITE_ASSET__DyUylZuz__"